<template>
  <div class="row mt-4">
    <div class="flex md12">
      <div class="row">
        <div class="flex md1">
          <va-button color="info" @click="createNew" icon="fa fa-plus" />
        </div>
        <div class="flex md11">
          <h4 class="fullwidth" style="position: relative;
          top: 0.5em;">Créer une relance</h4>
        </div>
      </div>
      <div class="row">
        <div class="flex md12" v-if="relanceList.length < 1">
          <p class="text--secondary">Aucune relance</p>
        </div>
      </div>
      <div class="row">
        <div
          class="row mt-1 clickable container-relances"
          :style="'max-height:' + setheight + 'em'"
        >
          <template v-for="relance in relanceList">
            <div class="row px-2 pt-2" @click="updateRelance(relance)">
              <div class="flex md3">
                <p>{{ convertDate(relance.date) }}</p>
              </div>
              <div class="flex md6">
                <p>{{ relance.text }}</p>
              </div>
              <div class="flex md3 test">
                <va-badge
                  class="button-statuts-relance cut-text"
                  large
                  :color="getColor(relance)"
                >{{ getStatutsText(relance) }}</va-badge>
              </div>
              <div class="flex md12">
                <p class="text--secondary">{{ getCommentText(relance) }}</p>
              </div>
              <div class="flex md12 row-separator" />
            </div>
          </template>
        </div>
      </div>
    </div>
    <va-modal
      :title="editTitle"
      large
      v-model="showEditor"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveRelance"
      v-on:cancel="closeModal"
    >
      <div class="row">
        <div class="flex md6">
          <p class="display-10 mb-2" :style="{ color: this.$themes.primary }">
            Créé le {{ activeRelance.date_creation }} par
            {{
            activeRelance.createur.prenom + " " + activeRelance.createur.nom
            }}
          </p>
        </div>
        <div class="flex md6">
          <p
            class="display-10 mb-2"
            :style="{ color: this.$themes.primary }"
            v-if="activeRelance.date_cloture"
          >
            Terminé le {{ activeRelance.date_cloture }} par
            {{ activeRelance.cloture.prenom + " " + activeRelance.cloture.nom }}
          </p>
        </div>
        <div class="flex md6 pa-1">
          <va-date-picker label="Date de relance" v-model="activeRelance.date" :error="dateNotSet" />
        </div>
        <div class="flex md6 pa-1">
          <va-select
            label="Assigner à:"
            v-model="selectAssignee"
            textBy="username"
            :options="userList"
          />
        </div>
        <div class="flex md12">
          <va-input
            v-model="activeRelance.text"
            label="Relance:"
            type="textarea"
            autosize
            :minRows="8"
            :maxRows="8"
            :error="textNotSet"
          />
        </div>
        <div class="flex md6">
          <va-button
            class="fullwidth"
            large
            :color="isClosed.color"
            @click="closeRelance()"
          >{{ isClosed.message }}</va-button>
        </div>
        <div class="flex md6">
          <va-button
            v-if="isAdmin"
            v-show="activeRelance.idrelance"
            class="fullwidth"
            large
            color="danger"
            @click="showConfirmDelete = true"
          >Supprimer la relance</va-button>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer cette relance?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteRelance()"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex } from "lodash";

export default {
  name: "relanceManager",
  props: ["identreprise", "setheight"],

  data() {
    return {
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      showConfirmDelete: false,
      textNotSet: false,
      dateNotSet: false,
      editTitle: "Editer la relance",
      selectAssignee: "",
      showEditor: false,
      today: new Date(),
      relanceList: [],
      newtext: null,
      newdate: null,
      statuts: "Créer une relance",
      statutsColor: "info",
      activeRelance: this.resetActiveRelance(),
      userList: this.loadUserList()
    };
  },
  mounted() {},
  methods: {
    loadUserList() {
      let list = cloneDeep(this.$store.getters.userList);

      if (list.length === 0) {
        //load user list
      } else {
        for (let i = 0; i < list.length; i++) {
          list[i].id = i + 1;
        }
      }
      return list;
    },
    createNew() {
      this.activeRelance = this.resetActiveRelance();
      this.editTitle = "Créer une relance";
      this.showEditor = true;
    },
    updateRelance(relance) {
      this.activeRelance = cloneDeep(relance);
      this.editTitle = "Editer la relance";

      if (relance.affectation_idutilisateur) {
        this.selectAssignee = find(this.userList, [
          "idutilisateurs",
          relance.affectation_idutilisateur
        ]);
      }
      this.showEditor = true;
    },
    closeRelance() {
      if (this.activeRelance.date_cloture) {
        //reopen the relance
        this.activeRelance.date_cloture = null;
        this.activeRelance.cloture_idutilisateur = null;
      } else {
        this.activeRelance.cloture_idutilisateur = this.$store.getters.user.idutilisateurs;
        this.activeRelance.cloture = {
          nom: this.$store.getters.user.nom,
          prenom: this.$store.getters.user.prenom
        };
        let today = new Date();
        let month = today.getUTCMonth() + 1; //months from 1-12
        let day = today.getUTCDate();
        let year = today.getUTCFullYear();

        let newdate = year + "-" + month + "-" + day;
        this.activeRelance.date_cloture = newdate;
      }
    },
    async deleteRelance() {
      if (this.activeRelance.idrelance) {
        try {
          let relancetodelete = cloneDeep(this.activeRelance);
          await axios.delete("/api/delete-relance", {
            data: relancetodelete
          });
          let index = findIndex(this.relanceList, {
            idrelance: this.activeRelance.idrelance
          });
          this.relanceList.splice(index, 1);
          this.activeRelance = this.resetActiveRelance();
          this.launchEpicmaxToast("Relance supprimée");
          this.showEditor = false;
        } catch (err) {
          console.log(err);
          this.launchEpicmaxToast("Erreur lors de la suppression");
        }
      } else {
        this.launchEpicmaxToast("La relance n'est pas sauvegardée");
      }
      this.textNotSet = false;
      this.dateNotSet = false;
    },
    getCommentText(relance) {
      if (relance.date_cloture)
        return (
          "Terminé le " +
          relance.date_cloture +
          " par " +
          relance.cloture.nom +
          " " +
          relance.cloture.prenom
        );

      if (relance.affectation) {
        return (
          "Affecté à " +
          relance.affectation.nom +
          " " +
          relance.affectation.prenom
        );
      }
      return "Créé par " + relance.createur.nom + " " + relance.createur.prenom;
    },

    getColor(relance) {
      if (relance.date_cloture) return "success";
      let ddiff = this.getDaysDifferences(relance.date);
      if (ddiff === 0) return "warning";
      if (ddiff < 0) return "info";
      return "danger";
    },
    getStatutsText(relance) {
      if (relance.date_cloture) return "Terminé";
      let ddiff = this.getDaysDifferences(relance.date);
      let jour = Math.abs(ddiff) === 1 ? " jour" : " jours";
      if (ddiff === 0) return "Relance aujourd'hui";
      if (ddiff < 0) return "Dans " + Math.abs(ddiff) + jour;
      return "Passée de " + Math.abs(ddiff) + jour;
    },
    convertDate(date) {
      let t = date.split("-");
      return t[2] + "-" + t[1] + "-" + t[0];
    },
    getDaysDifferences(date) {
      let today = new Date();
      let t = date.split("-");
      let dateRelance = new Date(
        t[0],
        t[1] - 1,
        t[2],
        t[3] || 0,
        t[4] || 0,
        t[5] || 0
      );
      var res = (this.today - dateRelance) / 1000;
      var days = Math.floor(res / 86400);
      return days;
    },
    async loadRelances(identreprise) {
      try {
        let rlist = await axios.get("/api/relance", {
          params: {
            id: identreprise
          }
        });
        this.relanceList = [];
        rlist.data.forEach(element => {
          if (!element.isformation) {
            this.relanceList.push(element);
          }
        });
        this.textNotSet = false;
        this.dateNotSet = false;
      } catch (error) {
        console.log(error);
      }
    },
    resetActiveRelance() {
      let today = new Date();
      let month = today.getUTCMonth() + 1; //months from 1-12
      let day = today.getUTCDate();
      let year = today.getUTCFullYear();

      let newdate = year + "-" + month + "-" + day;
      this.selectAssignee = "";
      return {
        idrelance: null,
        identreprise: this.identreprise,
        date: null,
        text: null,
        affectation_idutilisateur: null,
        createur_idutilisateur: this.$store.getters.user.idutilisateurs,
        cloture_idutilisateur: null,
        date_creation: newdate,
        date_cloture: null,
        createur: {
          nom: this.$store.getters.user.nom,
          prenom: this.$store.getters.user.prenom
        }
      };
      this.textNotSet = false;
      this.dateNotSet = false;
    },
    async saveRelance() {
      this.showEditor = true;
      // check that the mandatory fields are set
      if (!this.activeRelance.date) {
        this.dateNotSet = true;
      } else {
        this.dateNotSet = false;
      }
      if (!this.activeRelance.text) {
        this.textNotSet = true;
      } else {
        this.textNotSet = false;
      }

      //cannot save, return
      if (this.dateNotSet || this.textNotSet) return;

      try {
        //update the assignee if exist
        if (this.selectAssignee) {
          this.activeRelance.affectation_idutilisateur = this.selectAssignee.idutilisateurs;
        } else {
          this.activeRelance.affectation_idutilisateur = null;
        }
        //update or create
        if (this.activeRelance.idrelance) {
          let relanceres = await axios.post(
            "/api/update-relance",
            this.activeRelance
          );
          let updateRelance = relanceres.data;
          //update relance list
          let index = findIndex(this.relanceList, {
            idrelance: updateRelance.idrelance
          });
          this.relanceList.splice(index, 1, updateRelance);
          this.launchEpicmaxToast("Relance mise à jour");
          this.showEditor = false;
          this.activeRelance = this.resetActiveRelance();
        } else {
          let relanceres = await axios.post(
            "/api/create-relance",
            this.activeRelance
          );
          this.relanceList.unshift(relanceres.data);
          this.launchEpicmaxToast("Relance sauvegardée");
          this.showEditor = false;
          this.activeRelance = this.resetActiveRelance();
        }
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la sauvegarde");
      }
    },
    closeModal() {
      this.activeRelance = this.resetActiveRelance();
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  watch: {
    identreprise(newid) {
      if (newid) {
        this.loadRelances(newid);
      } else {
      }
    }
  },
  computed: {
    isClosed: function() {
      if (this.activeRelance.date_cloture)
        return { color: "success", message: "Rouvrir la relance" };

      return { color: "info", message: "Terminer la relance" };
    }
  }
};
</script>

<style lang="scss">
.container-relances {
  overflow: auto;
  overflow-x: hidden;
}
.clickable {
  display: flex;
  :hover {
    background-color: $light-gray3;
    cursor: pointer;
  }
}
.fullwidth {
  width: 95%;
}

.button-statuts-relance {
  position: relative;
  top: -0.3em;
  width: 95%;
  :hover {
    background-color: unset !important;
    color: unset !important;
  }
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.row-separator {
  width: 100%;
  border-color: #babfc2;
  border-width: 1px;
  border-bottom-style: solid;
}
.custom-button {
  width: 95%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
}
</style>
